export const AgentType = {
  GET_AGENT_DATA: "GET_AGENT_DATA",
  EDIT_AGENT_DATA: "EDIT_AGENT_DATA",
  EMPTY_AGENT_DATA: "EMPTY_AGENT_DATA",
  GET_ALL_AGENT: "GET_ALL_AGENT",
};
